import styled from 'styled-components';
import colors, { colorWithOpacity } from '../../helpers/colors';
import spacing from '../../helpers/spacing';

export const SolidBackground = styled.div`
  background-color: ${colorWithOpacity(colors.core01, 0.1)};
  /* takes background to full screen */
  margin: 0 calc(50% - 50vw) ${spacing(4)};
  /* resets the content back to the grid */
  padding: 0 calc(50vw - 50%);
  overflow: auto;
`;
